<template>
  <div id="body">
    <!--遮罩层-->
    <!-- <div v-if="this.dialogVisible" id="body1">
      <div><img alt="指引" class="body1-img" src="../assets/57@3x.png"></div>
      <div id="font1" class="body1-font">点击右上角</div>
      <div id="font2" class="body1-font">用浏览器打开并下载</div>
    </div> -->

    <div v-if="type === 2">
      <div id="head">
        <div class="title">
          <div id="title-img"><img alt="" class="img" src="../assets/tpWarn@3x.png"></div>
          <div id="title-font">关注公众号</div>
        </div>
        <div id="title2">
          线上激活电子保修卡
        </div>
        <div class="code">
          <img alt="二维码" class="code-img" src="../assets/code.jpg">
        </div>
        <div class="title4">
          长按识别图中二维码
        </div>
      </div>
    </div>
    <div v-if="type === 1">
      <!--  :href="hrefUrl" download="TORO"  -->
      <div style="color: #2b3335">
        <div id="head2">
          <div class="title" style="display: flex;justify-content: center;align-items: center;width: 280px;" v-show="isResponse">
            <div id="title-img1"><img alt="" class="img" :src="AppName == 'TORO车辆轮端预警'?'/static/AppIcon.png':'/static/RHC.png'"></div>
            <div id="title-font2">
              <div>
                欢迎使用{{AppName}}
              </div>
              <div>
                打开小程序查看车辆状态
              </div>
            </div>
          </div>
          <div v-if="dialogVisible && Boolean(AppletPrimitiveId)" style="display: flex;justify-content: center;align-items: center;"> 
            <!-- env-version="trial" -->
            <wx-open-launch-weapp
              id="launch-btn"
              :username="AppletPrimitiveId"
              :path="sn?'pages/tabBar/home.html?sn='+sn:'pages/tabBar/home.html'"
              env-version="trial"
              @launch="handleLaunchFn"
              @error="handleErrorFn"
              style="width: 250px;"
            >
              <script type="text/wxtag-template">
                <style>
                  .open{
                    padding: 15px;
                    text-align: center;
                    margin-top: 100px;
                  }
                  .btn{
                    background-color: #19be6b;
                    color: white;
                    padding: 15px 30px;
                    border: none;
                    border-radius: 5px;
                    font-size: 25px;
                  }
                </style>
                <div class="open">
                  <button class="btn">打开小程序</button>
                </div>
              </script>
            </wx-open-launch-weapp>
          </div>
           <div v-if="!dialogVisible" class="code">
            <!-- <img :src="this.downUrl" alt="二维码" class="code-img"> -->
            <div style="font-size: 18px;color: rgba(0, 0, 0, 1);padding-top: 15px;">
              请使用微信打开
            </div>
          </div>
          <!-- <div v-else class="code">
            <img :src="this.downUrl" alt="二维码" class="code-img">
            <div style="font-size: 18px;color: rgba(0, 0, 0, 1);padding-top: 15px;">
              请保存二维码，在微信中识别
            </div>
          </div> -->
        </div>
      </div>
      <!-- <div v-if="AppName == 'TORO'" class="button" style="border-top:1px solid #767474" v-on:click="gotoType()">
        电子保修卡
        <div class="symbol">></div>
      </div> -->
    </div>
    <!-- <a v-if="AppName == 'TORO'" :href="this.explainUrl">
      <div class="button" style="border-bottom:1px solid #767474;border-top:1px solid #767474;">
        查看说明书
        <div class="symbol">></div>
      </div>
    </a> -->
  </div>
</template>
<script>
import {getSign,imeiSn} from '../api/api';
export default {
  data() {
    return {
      hrefUrl: '',
      dialogVisible: true,
      type: 1,
      explainUrl: '',
      downUrl: 'https://cv.e5ex.cn/app/qrCode/iphone.png',
      sn: "",
      AppletPrimitiveId: "",
      AppName: "",
      isResponse: false
    };
  },
  created() {
    this.checkViewport();
  },
  mounted(){
    this.ToMiniapp();
  },
  methods: {
    handleLaunchFn(e) {
      console.log('success', e.detail);
        // window.open("https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzkzMTE4MDY5MA==#wechat_redirect");
    },
    handleErrorFn(e){
      console.log('fail', e.detail);
    },
    ToMiniapp() {
      // window.location.href.split('#')[0]
      // window.location.href.split('R')[1].substr(3,window.location.href.split('/#/')[1].length)
      getSign(window.location.href.split('/#/')[0],window.location.href.split('/#/')[1]).then(({code, msg, data}) => {
        if (code === 0) {
          this.AppletPrimitiveId = data.AppletPrimitiveId;
          this.AppName = (data.AppName == 'TORO'?data.AppName+'智能胎压':'RHC润通汽配制动监测');
          this.isResponse = true;
          document.title = this.AppName;
          wx.config({
            debug: false,
            appId: "wxa897b31443ea9c96",
            signature: data.signature,
            nonceStr: data.nonceStr,
            timestamp: data.timestamp,
            jsApiList: [],
            openTagList: ["wx-open-launch-weapp"]
          });
          wx.ready(() => {
            console.log('wx ready')
          });
          wx.error(function (res) {
            console.log("error",res)
          });
        } else {
          this.$message.error(msg);
        }
      });
    },
    // 查看当前配置
    checkViewport() {
      //判断设备 /R862177043673170
      let path = this.$router.currentRoute.path;
      this.sn = 'https://e5ex.com/'+window.location.href.split('/#/')[1];
      //下载APP
      if (path.substr(1, 1) === 'R' || path.substr(1, 4) === 'show') {
        this.type = 1;
      }
      //关注公众号
      else if (path.substr(1, 1) === 'A') {
        this.type = 2;
        this.sn = "";
      }
      let u = navigator.userAgent;
      let platform = navigator.platform;
      if (u.toLowerCase().match(/MicroMessenger/i) == "micromessenger") {
        this.dialogVisible = true;
      }else{
        this.dialogVisible = false;
      }
      // 判断是否是微信内核
      // if (/MicroMessenger/i.test(u.toLowerCase())) {
      //   if (u.indexOf('iPhone') > -1) {
      //     //苹果微信浏览器
      //     this.hrefUrl = 'https://apps.apple.com/cn/app/toro%E8%83%8E%E5%8E%8B/id1521589697';
      //     this.downUrl = 'https://cv.e5ex.cn/app/qrCode/iphone1.png';
      //   } else if (u.indexOf('Android') > -1) {
      //     if (this.type === 1) {
      //       //安卓微信浏览器
      //       // this.dialogVisible = true;
      //     }
      //     this.hrefUrl = 'https://cv.e5ex.cn/app/Tp.apk';
      //     this.downUrl = 'https://cv.e5ex.cn/app/qrCode/Android1.png';
      //   } else if (/Win\d{2}|Windows/.test(platform) || !!u.match(/\(Macintosh; Intel /)) {
      //     //电脑微信浏览器
      //     this.hrefUrl = 'https://cv.e5ex.cn/app/Tp.apk';
      //     this.downUrl = 'https://cv.e5ex.cn/app/qrCode/Android1.png';
      //   }
      // } else if (u.indexOf('Android') > -1 || u.indexOf('iPhone') > -1) {
      //   // 其他浏览器内核   判断是否是安卓还是IOS
      //   if (u.indexOf('iPhone') > -1) {
      //     //iPhone其他浏览器
      //     this.hrefUrl = 'https://apps.apple.com/cn/app/toro%E8%83%8E%E5%8E%8B/id1521589697';
      //     this.downUrl = 'https://cv.e5ex.cn/app/qrCode/iphone1.png';
      //   } else if (u.indexOf('Android') > -1) {
      //     //Android其他浏览器
      //     this.hrefUrl = 'https://cv.e5ex.cn/app/Tp.apk';
      //     this.downUrl = 'https://cv.e5ex.cn/app/qrCode/Android1.png';
      //     window.location.href = 'https://cv.e5ex.cn/app/Tp.apk'
      //   }
      // } else if (/Win\d{2}|Windows/.test(platform) || !!u.match(/\(Macintosh; Intel /)) {
      //   //电脑端其他浏览器
      //   this.hrefUrl = 'https://cv.e5ex.cn/app/Tp.apk';
      //   this.downUrl = 'https://cv.e5ex.cn/app/qrCode/Android1.png';
      // }

      let query = path.substr(2, 3);
      // if(path.indexOf("/R") !== -1){
      //   imeiSn(path.replace('/R','')).then(res => {
      //     if((res.data?true:false) && (res.data.indexOf("R3") !== -1)){
      //       this.explainUrl = "https://portal.e5ex.cn/manual/r3";
      //     }else if(query === "R64" || query === 'R14') {
      //       this.explainUrl = "https://portal.e5ex.cn/manual/r2";
      //     } else if (query.substr(0, 2) === "Rk") {
      //       this.explainUrl = "https://portal.e5ex.cn/manual/k1";
      //     } else if (query.substr(0, 2) === "RZ") {
      //       this.explainUrl = "https://portal.e5ex.cn/manual/t1";
      //     } else {
      //       this.explainUrl = "https://portal.e5ex.cn/manual/r1";
      //     }
      //   });
      // }else if(path.indexOf("/show") !== -1){
      //   imeiSn(path.replace('/show','')).then(res => {
      //     if((res.data?true:false) && (res.data.indexOf("R3") !== -1)){
      //       this.explainUrl = "https://portal.e5ex.cn/manual/r3";
      //     }else if(query === "R64" || query === 'R14') {
      //       this.explainUrl = "https://portal.e5ex.cn/manual/r2";
      //     } else if (query.substr(0, 2) === "Rk") {
      //       this.explainUrl = "https://portal.e5ex.cn/manual/k1";
      //     } else if (query.substr(0, 2) === "RZ") {
      //       this.explainUrl = "https://portal.e5ex.cn/manual/t1";
      //     } else {
      //       this.explainUrl = "https://portal.e5ex.cn/manual/r1";
      //     }
      //   });
      // }else{
      //   if(query === "R64" || query === 'R14') {
      //       this.explainUrl = "https://portal.e5ex.cn/manual/r2";
      //     } else if (query.substr(0, 2) === "Rk") {
      //       this.explainUrl = "https://portal.e5ex.cn/manual/k1";
      //     } else if (query.substr(0, 2) === "RZ") {
      //       this.explainUrl = "https://portal.e5ex.cn/manual/t1";
      //     } else {
      //       this.explainUrl = "https://portal.e5ex.cn/manual/r1";
      //     }
      // }
      
    },
    gotoType() {
      this.type = 2;
    }
  }
}
</script>
<style scoped>
.btn:active{
  background-color: rgba(25, 190, 107, 0.8);
}
.body1-img {
  position: absolute;
  height: 50px;
  width: 90px;
  right: 20px;
  top: 10px;
}

.body1-font {
  position: absolute;
  color: rgba(255, 255, 255, 0.87);
  font-size: 20px;
}

#font1 {
  top: 45px;
  right: 120px;
}

#font2 {
  top: 80px;
  right: 40px;
}

#body {
  height: 100%;
  width: 100%;
  position: absolute;
  background: url("../assets/back.jpg");
  background-size: 80%;
}

#body1 {
  position: fixed;
  background: rgba(0, 0, 0, 0.67);
  z-index: 1020000000000000;
  height: 100%;
  width: 100%;
}

#head {
  height: 320px;
  width: 200px;
  margin: 80px auto 40px;
}

#head2 {
  height: 280px;
  width: 250px;
  margin: 80px auto 40px;
  position: relative;
}

.title {
  width: calc(100% + 2px);
  height: 40px;
  display: flex;
  align-items: center;
}

#title2 {
  width: 100%;
  height: 20px;
  margin: 15px 10px;
  font-size: 20px;
  color: #878787;
}

.title3 {
  width: 100%;
  height: 20px;
  margin: 15px 70px;
  font-size: 16px;
}

.title4 {
  width: 100%;
  height: 20px;
  margin: 15px 28px;
  font-size: 16px;
}

.img {
  height: 45px;
  width: 45px;
}

#title-img {
  float: left;
}

#title-img1 {
  float: left;
  display: flex;
  align-content: center;
}
#title-img1 > img{
  border-radius: 7.5px;
}

#title-font2 {
  font-family: Source Han Sans CN, sans-serif;
  float: left;
  font-size: 16px;
  line-height: 25px;
  margin-left: 8px;
  color: rgba(0, 0, 0, 1);
}

#title-font {
  font-family: Source Han Sans CN, sans-serif;
  float: right;
  font-weight: 1000;
  font-size: 30px;
  line-height: 40px;
}

.code {
  height: 180px;
  width: 100%;
  text-align: center;
  margin: 30px 0;
}

.code-img {
  height: 180px;
  width: 180px;
}

.button {
  height: 42px;
  width: 85%;
  margin: 0 auto auto;
  font-size: 20px;
  line-height: 40px;
  color: #808080;
}

.symbol {
  float: right;
  margin: auto 0;
}

a {
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/components/testDownload.vue